import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnDestroy, ViewChild } from '@angular/core';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';
import {
    MAT_LEGACY_DIALOG_DATA,
    MatLegacyDialog,
    MatLegacyDialogConfig as MatDialogConfig,
    MatLegacyDialogModule,
    MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {
    BehaviorSubject,
    combineLatest,
    firstValueFrom,
    from,
    map,
    merge,
    Observable,
    of,
    ReplaySubject,
    Subscription,
} from 'rxjs';
import { debounceTime, startWith, take } from 'rxjs/operators';
import { FileDataService } from '../../../../dave-data-module/services/file-data.service';
import { InvoicingDataService } from '../../../../dave-data-module/services/invoicing-data.service';
import {
    SelectFolderDialogComponent,
    SelectFolderDialogComponentDialogData,
    SelectFolderDialogComponentDialogReturnData,
} from '../../../../dave-file-explorer/components/select-folder-dialog/select-folder-dialog.component';
import { DaveLoadingModule } from '../../../../dave-loading/dave-loading.module';
import { appMatDialogDefaultConfig, isNotNullOrUndefined } from '../../../../helper/helper';
import { ArlTreeComponent, ArlTreeItem, ArlTreeRowDirective } from '../../../arl-tree/arl-tree/arl-tree.component';
import { arlTableDataArlForm } from '../arl-form-data.service';
import { AppButtonModule } from '../../../../dave-utils-module/app-button-module/app-button.module';
import { MatLegacyCardModule } from '@angular/material/legacy-card';
import { MatLegacyFormFieldModule } from '@angular/material/legacy-form-field';
import { SelectSearchModule } from '../../../../dave-utils-module/select-search/select-search.module';
import { FormArray, FormControl, FormGroup, FormRecord, ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import { MatLegacyTooltipModule } from '@angular/material/legacy-tooltip';
import { MatLegacyInputModule } from '@angular/material/legacy-input';
import {
    getQuantityTypeById,
    getQuantityTypes,
    getQuantityTypesFetched,
} from '../../../../dave-data-module/State/selectors/accounting.selector';
import { getFetched$ } from '../../../../dave-data-module/helper/helper';
import { Store } from '@ngrx/store';
import { State } from '../../../../dave-data-module/State';
import { MatLegacyCheckboxModule } from '@angular/material/legacy-checkbox';
import {
    AccountsReceivableLedgerTypeEnum,
    financialRound,
} from '../../../../dave-data-module/entities/accounts-receivable-ledger.entity';
import { ArlDataFromFile, PriceComparison } from '@dave/types';
import {
    AppConfirmationDialogComponent,
    AppConfirmationDialogData,
} from '../../../../dave-utils-module/app-dialog-module/app-confirmation-dialog/app-confirmation-dialog.component';
import {
    SelectSupplierDialogComponent,
    SelectSupplierDialogData,
    SelectSupplierDialogReturnData,
} from '../../select-supplier-dialog/select-supplier-dialog.component';
import { FolderTypes } from '../../../../dave-data-module/entities/folder.entity';
import { FolderDataService } from '../../../../dave-data-module/services/folder-data.service';
import { getCustomerById } from '../../../../dave-data-module/State/selectors/customers.selectors';
import { MatLegacyTableModule } from '@angular/material/legacy-table';
import {
    PriceComparisonLongInformationDialogComponentDialogData,
    PriceComparisonLongInformationDialogComponentDialogReturnData,
    PriceComparisonLongtextDialogComponent,
} from '../../price-comparison-longtext-dialog/price-comparison-longtext-dialog.component';
import { HintIconComponent } from '../../../../hint-icon/hint-icon.component';
import { LoadingService } from '../../../../services/loading.service';
import { MatLegacyMenuModule } from '@angular/material/legacy-menu';
import {
    DaveSelectFileFromDmsComponent,
    DaveSelectFileFromDmsComponentDialogData, DaveSelectFileFromDmsComponentReturnData,
} from '../../../../dave-select-file-from-dms/components/dave-select-file-from-dms/dave-select-file-from-dms.component';



// export interface PriceComparisonComponentDialogData<InputFormValue> {
//    // inputFormValue: arlTableDataArlForm['value'][];
//     inputFormValue: PriceComparisonTreeNode[];
//     ledgerImportId: number;
//     priceComparisons: PriceComparison[]
//     //priceComparisonIds: number[]; Entieties
// }


export interface PriceComparisonBaseItem {
    Id?: number;
    ItemNumber: string;
    Information: string;
    Longtext: string;
    CostAmount: number;
    Quantity: number;
    QuantityTypeId: number;
    ChangedAfterSelectedFromPriceComparison: boolean;
}

export interface PriceComparisonComponentDialogData<T extends PriceComparisonBaseItem> {
    inputFormValue: Array<T>;

    getId: (item: T) => number;
    getChildren: (item: T) => T[];
    getType: (item: T) => AccountsReceivableLedgerTypeEnum | null;
    getQuantity: (item: T) => number | null;
    getMaterialId: (item: T) => number | null;
    getFileData: (fileVersionId: number) => Promise<{
        matchedId: number | null;
        price: number | null;
    }[] | null>;
    priceComparisons: PriceComparison[];
}
export type PriceComparisonComponentDialogReturnData = | undefined
    | {
    SavePrices: boolean;
    BidderData: {
        dirty: boolean;
        priceComparisonId: string | null;
        fileName: string;
        customerId: number;
        rabatt: number;
        skonto: number;
        positions: PositionValuePriceComparison[];
        /**
         * ist nicht gefüllt wenn aus bestehender PriceComparison entity erstellt, also nur bei von price-comparison neu angelegten vorhanden
         */
        documentId: number;
    }[];
};

export interface PositionValuePriceComparison extends PriceComparisonPosition {
    changed: boolean;
}

export interface PriceComparisonPosition{
    isGroup: boolean;
    selectAble: boolean;
    selected: boolean;
    piecePrice: number | null;
    discountPrice: number | null;
    sumPrice: number | null;
    loadingMaterialPrice: boolean;
    materialId: number;
    arlId: number;  //ToDo ggf. Umbennen zu entityId?
    quantity:number | null;
    itemNumber: string;
}



type BidderFormGroup = FormGroup<{
    customerId: FormControl<number | null>;
    rabatt: FormControl<number | null>;
    skonto: FormControl<number | null>;
    sumPicePrice: FormControl<number | null>;
    sumDiscountPrice: FormControl<number | null>;
    sumSumPrice: FormControl<number | null>;
    selectAble: FormControl<boolean>;
    priceComparisonId: FormControl<string | null>;
    //priceComparisonId: FormControl<number | null>;
    positions: FormRecord<FormGroup<{
        isGroup: FormControl<boolean>;
        selectAble: FormControl<boolean>;
        selected: FormControl<boolean>;
        piecePrice: FormControl<number | null>;
        discountPrice: FormControl<number | null>;
        sumPrice: FormControl<number | null>;
        loadingMaterialPrice: FormControl<boolean>;
        materialId: FormControl<number>;
        arlId: FormControl<number>;
        quantity:FormControl<number | null>;
        changed: FormControl<boolean>;
        itemNumber: FormControl<string>;
    }>>;
}>;

interface bidderData {
    bidderName: string;
    fileName: string;
    documentId: number;
    formGroup: BidderFormGroup;
}

type ArlNode<T> = ArlTreeItem<Partial<T>>;

@Component({
    selector: 'app-price-comparison',
    standalone: true,
    imports: [CommonModule, ArlTreeComponent, ArlTreeRowDirective, FontAwesomeModule, MatLegacyButtonModule, DaveLoadingModule, AppButtonModule, MatLegacyCardModule, MatLegacyFormFieldModule, SelectSearchModule, ReactiveFormsModule, MatLegacyTooltipModule, MatLegacyInputModule, MatLegacyDialogModule, MatLegacyCheckboxModule, MatLegacyTableModule, HintIconComponent, MatLegacyMenuModule],
    templateUrl: './price-comparison.component.html',
    styleUrls: ['./price-comparison.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PriceComparisonComponent<InputFormValue extends PriceComparisonBaseItem> implements OnDestroy{
    public static DefaultConfig: MatDialogConfig = {
        ...appMatDialogDefaultConfig,
        hasBackdrop: false,
        height: '100vh',
        width: '100vw',
        maxHeight: '100vh',
    };

    protected bidderData: Array<bidderData> = [];
    protected biddersFormArray = new FormArray<BidderFormGroup>([]);
    protected data: InputFormValue[];


    private dataFilterSubscription: Subscription;
    private treeExpansionSub: Subscription;
    private formSubscriptions: Subscription[] = [];
    protected trackByNodeId = (i:number, node: ArlNode<InputFormValue>) => node.data.Id;
    protected trackByBidderIndex = (i: number) => i;

    protected quantityTypeNames = new Map<number, string>();
    positionMap = new Map<number, FormGroup>();

    @ViewChild('tree') set tree(value: ArlTreeComponent<InputFormValue, any>) {
        this.treeExpansionSub?.unsubscribe();
        if (value) {
            this._tree = value;
            if (value.treeControl && value.dataSource._treeFlattener) {

                this.treeExpansionSub =  value.treeControl.expansionModel.changed.pipe(
                    startWith(null)
                ).subscribe(() => {
                    const expandedNodes = value.dataSource._treeFlattener.expandFlattenedNodes(
                        value.treeControl.dataNodes,
                        value.treeControl
                    );
                    this.visibleNodes$.next(expandedNodes);
                });
            }

        }
    }
    get tree() {
        return this._tree;
    }
    private _tree: ArlTreeComponent<InputFormValue, any>;

    public SearchForm = new UntypedFormControl('');

    protected visibleNodes$ = new BehaviorSubject<ArlNode<InputFormValue>[]>([]);

    protected filteredVisibleNodes$: Observable<ArlNode<InputFormValue>[]> = combineLatest([
        this.visibleNodes$,
        merge(
            of(null as string),
            this.SearchForm.valueChanges.pipe(debounceTime(300))
        )
    ]).pipe(
        map(([nodes, searchTerm]) => {
            const term = (searchTerm || '').toLowerCase().trim();
            if (!term) return nodes;

            const directMatchIds = new Set(
                nodes
                    .filter(n =>
                        n.data.Information?.toLowerCase().includes(term) ||
                        n.data.Longtext?.toLowerCase().includes(term) ||
                        n.data.ItemNumber?.toLowerCase().includes(term),
                    )
                    .map(n => n.data.Id),
            );

            const ancestorIds = new Set<number>();
            nodes.forEach((node, i) => {
                if (directMatchIds.has(node.data.Id)) {
                    let currentLevel = node.level;
                    for (let j = i - 1; j >= 0 && currentLevel > 0; j--) {
                        if (nodes[j].level < currentLevel) {
                            ancestorIds.add(nodes[j].data.Id);
                            currentLevel = nodes[j].level;
                        }
                    }
                }
            });

            return nodes.filter(n => directMatchIds.has(n.data.Id) || ancestorIds.has(n.data.Id));
        }),
    );

    constructor(
        @Inject(MAT_LEGACY_DIALOG_DATA)
        protected dialogData: PriceComparisonComponentDialogData<InputFormValue>,
        private dialogRef: MatDialogRef<PriceComparisonComponent<InputFormValue>>,
        private dialog: MatLegacyDialog,
        private fileDataService: FileDataService,
        private invoicingService: InvoicingDataService,
        private cdr: ChangeDetectorRef,
        private store: Store<State>,
        private folderDataService: FolderDataService,
        private ls: LoadingService,
    ) {
        this.data = dialogData.inputFormValue;
        this.initGroupCostAmounts(this.data);
        getFetched$(this.store, getQuantityTypesFetched, getQuantityTypes).pipe(take(1)).subscribe(types => types.forEach(t => this.quantityTypeNames.set(t.Id, t.Name)))



        if(dialogData.priceComparisons.length > 0) {
            Promise.all(dialogData.priceComparisons.map((priceComparison) => this.addPriceComparison(priceComparison))).then(() => {
                this.updateArlFilter();
                this.ls.endLoading("openPriceComparison");
                this.cdr.markForCheck();
            });
        }else{
            this.arlFilter$.next(() => true);
            this.ls.endLoading("openPriceComparison");
        }
    }
    private hasValidChildRecursive(item: InputFormValue): boolean {
        const children = this.dialogData.getChildren(item);
        const type = this.dialogData.getType(item);
        if (!children.length) {
            return type !== AccountsReceivableLedgerTypeEnum.Text
                && type !== AccountsReceivableLedgerTypeEnum.Group;
        }
        return children.some(child => this.hasValidChildRecursive(child));
    }

    private initGroupCostAmounts(items: InputFormValue[]): number {
        let total = 0;

        for (let i = items.length - 1; i >= 0; i--) {
            const item = items[i];
            const children = this.dialogData.getChildren(item)
            if (children?.length) {

                const childTotal = this.initGroupCostAmounts(children);

                const hasValidChilds = children.some(child =>
                    this.hasValidChildRecursive(child)
                );

                if (!hasValidChilds) {
                    items.splice(i, 1);
                    continue;
                }

                item.CostAmount = childTotal;
                total += item.CostAmount;

            } else {
                total += (item.CostAmount ?? 0) * (item.Quantity ?? 1);
            }
        }

        return total;
    }

    ngOnDestroy(): void {
        this.dataFilterSubscription?.unsubscribe();
        this.treeExpansionSub?.unsubscribe();
        this.formSubscriptions.forEach(sub => sub?.unsubscribe());
    }
    protected getChildren = (a: InputFormValue) => this.dialogData.getChildren(a);
    protected getPosition: (a: InputFormValue) => string = (a) => a.ItemNumber;
    protected arlFilter$ = new ReplaySubject<(a: InputFormValue) => boolean>();


    private async addPriceComparison(priceComparison: PriceComparison){
        const jsonData : PriceComparisonPosition[] = JSON.parse(priceComparison.PositionData)


        const flatten = (data: InputFormValue[]): InputFormValue[] =>
            data.flatMap(d => [d, ...flatten(this.dialogData.getChildren(d))]);
        const allArls = flatten(this.data);
        let allSelectable = true


        let posPiecePriceSum = 0;


        const posValues: {[key: string]: PositionValuePriceComparison} = {};
        jsonData.forEach((pos: PriceComparisonPosition) => {
                if(!pos.isGroup) {
                    posPiecePriceSum += pos.piecePrice || 0;
                }
                let changed = false;
                if(pos.selected) {
                    changed = allArls.some(d =>
                        d.Id === pos.arlId && d.ChangedAfterSelectedFromPriceComparison
                    );
                }
                if (!pos.selectAble && allSelectable){
                    allSelectable = false;
                }

            posValues[pos.arlId.toString()] = {
                changed: changed,
                isGroup: pos.isGroup,
                selectAble: pos.selectAble,
                selected: pos.selected,
                piecePrice: pos.piecePrice,
                discountPrice: pos.discountPrice,
                sumPrice: pos.sumPrice,
                loadingMaterialPrice: pos.loadingMaterialPrice,
                materialId: pos.materialId,
                arlId: pos.arlId,
                quantity: pos.quantity,
                itemNumber: pos.itemNumber,
            };
        });

        console.log('## ', posValues)
        const bidderFormGroup: BidderFormGroup = new FormGroup({
            customerId: new FormControl<number | null>(+priceComparison.SupplierId ),
            rabatt: new FormControl<number | null>(priceComparison?.RabattPercent ? +priceComparison.RabattPercent : null),
            skonto: new FormControl<number | null>(priceComparison?.SkontoPercent ? +priceComparison.SkontoPercent : null),
            sumPicePrice: new FormControl<number | null>(posPiecePriceSum),
            sumDiscountPrice: new FormControl<number | null>(null),
            sumSumPrice: new FormControl<number | null>(null),
            selectAble: new FormControl<boolean>(allSelectable),
            priceComparisonId: new FormControl<string | null>(priceComparison.Id),
            positions: new FormRecord(
                Object.fromEntries(
                    Object.entries(posValues).map(([key, value]) => [
                        key,
                        new FormGroup({
                            isGroup: new FormControl(value.isGroup),
                            selectAble: new FormControl(value.selectAble),
                            selected: new FormControl({
                                value: value.selected,
                                disabled: !value.selectAble
                            }),
                            piecePrice: new FormControl(value.piecePrice),
                            discountPrice: new FormControl(value.discountPrice),
                            sumPrice: new FormControl(value.sumPrice),
                            loadingMaterialPrice: new FormControl(value.loadingMaterialPrice),
                            materialId: new FormControl(value.materialId),
                            arlId: new FormControl(value.arlId),
                            quantity: new FormControl(value.quantity),
                            changed: new FormControl(value.changed),
                            itemNumber: new FormControl(value.itemNumber),
                        })
                    ])
                )
            )
        });

        const customer = await firstValueFrom(this.store.select(getCustomerById({ id: +priceComparison.SupplierId })));
        this.biddersFormArray.push(bidderFormGroup);
        this.bidderData.push({
            bidderName: customer.DisplayName,
            fileName: priceComparison.FileName,
            // documentId: priceComparison.DocumentId,
            formGroup: bidderFormGroup,
            documentId: null, // wird nicht mit gespeichert
        });

         this.recalculatePrices(bidderFormGroup);
        const rabattSub = bidderFormGroup.controls.rabatt.valueChanges.pipe(debounceTime(500)).subscribe(() => {
            this.recalculatePrices(bidderFormGroup);
        });
        const skontoSub = bidderFormGroup.controls.skonto.valueChanges.pipe(debounceTime(500)).subscribe(() => {
            this.recalculatePrices(bidderFormGroup);
        });
        this.formSubscriptions.push(rabattSub, skontoSub);


    }

    protected async onSelectFileClick() {
        const supplierRes = await firstValueFrom(this.dialog.open<SelectSupplierDialogComponent, SelectSupplierDialogData, SelectSupplierDialogReturnData>(SelectSupplierDialogComponent, {
            data: {
                header: "Bieter hinzufügen",
                showCheckbox: false,
                infoText: 'Schritt 1: Bieter wählen \n' +
                    'Schritt 2: Datei vom Bieter einspielen',
            }
        }).afterClosed());
        if (!supplierRes.Confirmed) {
            return;
        }
        const folder = await firstValueFrom(this.folderDataService.getFolderFromEntity(supplierRes.SupplierId, FolderTypes.customer))
        const selectFileResult = await firstValueFrom(
            this.dialog
                .open<DaveSelectFileFromDmsComponent, DaveSelectFileFromDmsComponentDialogData, DaveSelectFileFromDmsComponentReturnData>(DaveSelectFileFromDmsComponent, {
                    ...DaveSelectFileFromDmsComponent.DefaultConfig,
                    data: {
                        moveWarning: '',
                        preSelectedFiles: [],
                        maxFiles: 1,
                        folderId: folder.Id,
                    },
                })
                .afterClosed(),
        );
        if(selectFileResult.documents.length !== 0) {

            this.addBidderFromFile(selectFileResult.documents[0], supplierRes.SupplierId)
        }
      }
    protected async onUploadFileClick(){
        const supplierRes = await firstValueFrom(this.dialog.open<SelectSupplierDialogComponent, SelectSupplierDialogData, SelectSupplierDialogReturnData>(SelectSupplierDialogComponent, {
            data: {
                header: "Bieter hinzufügen",
                showCheckbox: false,
                infoText: 'Schritt 1: Bieter wählen \n' +
                    'Schritt 2: Datei vom Bieter einspielen',
            }
        }).afterClosed());
        if (!supplierRes.Confirmed) {
            return;
        }
        const folder = await firstValueFrom(this.folderDataService.getFolderFromEntity(supplierRes.SupplierId, FolderTypes.customer))

        const uploadFileResult = await firstValueFrom(
            this.dialog
                .open<SelectFolderDialogComponent, SelectFolderDialogComponentDialogData, SelectFolderDialogComponentDialogReturnData>(SelectFolderDialogComponent, {
                    ...SelectFolderDialogComponent.DefaultConfig,
                    data: {
                        folderId: folder.Id,
                        ButtonText: 'HOCHLADEN',
                        matTreeNodePaddingIndent: 10,
                        uploadMode: true,
                        synchronUpload: true,
                        maxFilesUpload: 1,
                        //  acceptedFiles: [this.mimeType, this.fileExtension].join(','),
                    },
                })
                .afterClosed(),
        );
        if (!uploadFileResult?.synchronUploadedDocuments?.length) {
            return;
        } else if (uploadFileResult.synchronUploadedDocuments?.length > 1) {
            console.error('mehr als eine datei ausgewählt');
            return;
        }
        this.addBidderFromFile(uploadFileResult.synchronUploadedDocuments[0].Id, supplierRes.SupplierId)
    }


    protected async addBidderFromFile(documentId: number, supplierId: number) {

        // this.ls.startLoading("addBidderFromFile")
        // const file = await firstValueFrom(this.fileDataService.GetFileById$(documentId));
        // const customer = await firstValueFrom(this.store.select(getCustomerById({ id: supplierId })));
        //
        //
        // await firstValueFrom(from(this.invoicingService.getInvoiceDataFromFile(file.GetLastVersion().Id, this.ledgerImportId)).pipe(
        //     map((dataFromFile) => {
        //
        //         let picePriceSum = 0;
        //         let sumPriceSum = 0;
        //
        //         const arlDataFromFileMap = new Map<number, ArlDataFromFile>();
        //         if(!dataFromFile){
        //             this.ls.endLoading("addBidderFromFile")
        //             return;
        //         }
        //
        //
        //         dataFromFile.forEach((d) => {
        //             if (d.matchedArlId?.length > 0) {
        //                 arlDataFromFileMap.set(+d.matchedArlId, d);
        //             }
        //
        //         });
        //
        //
        //         const flatten = (data: arlTableDataArlForm['value'][]): arlTableDataArlForm['value'][] => {
        //             return data.flatMap(d => [d, ...(d.childArls ? flatten(d.childArls) : [])]);
        //         };
        //
        //         const allArls = flatten(this.data);


        this.ls.startLoading("addBidderFromFile");
        const file = await firstValueFrom(this.fileDataService.GetFileById$(documentId));
        const customer = await firstValueFrom(this.store.select(getCustomerById({ id: supplierId })));

        const dataFromFile = await this.dialogData.getFileData(
            file.GetLastVersion().Id
        );
        if (!dataFromFile) {
            this.ls.endLoading("addBidderFromFile");
            return;
        }

        const fileDataMap = new Map<number, { price: number | null }>();
        dataFromFile.forEach(d => {
            if (d.matchedId != null) {
                fileDataMap.set(d.matchedId, { price: d.price });
            }
        });

        const flatten = (data: InputFormValue[]): InputFormValue[] =>
            data.flatMap(d => [d, ...flatten(this.dialogData.getChildren(d))]);

        const allItems = flatten(this.data);
        let picePriceSum = 0;
        let sumPriceSum = 0;
                const calculateGroupPrice = (item: InputFormValue): {
                    positionExisting: boolean,
                    price: number,
                    sum: number
                } => {
                    let totalSum = 0;

                    const type = this.dialogData.getType(item);
                    const id = this.dialogData.getId(item);
                    const childs = this.dialogData.getChildren(item);

                    if (type !== AccountsReceivableLedgerTypeEnum.Group && type !== AccountsReceivableLedgerTypeEnum.Text) {
                        const dataFromFile = fileDataMap.get(id);


                        if (!dataFromFile) {
                            return { positionExisting: false, price: 0, sum: 0 };
                        }

                        const price = dataFromFile.price ?? 0;


                        const sum = (this.dialogData.getQuantity(item) ?? 1) * price;
                        return { positionExisting: true, price, sum };
                    }
                    let poisitonExisting = true;
                    childs.forEach(child => {
                        const result = calculateGroupPrice(child);
                        if (!result.positionExisting) {
                            poisitonExisting = false;
                        }
                        totalSum += result.sum;
                    });

                    return {
                        positionExisting: poisitonExisting,
                        price: totalSum,
                        sum: totalSum,
                    };
                };


                let positionsExisting = true;
                const posValues: {
                    [key: string]: PositionValuePriceComparison
                } = {};

        allItems.forEach((d) => {
                    let isGroup = false;
                    const id = this.dialogData.getId(d);
                    const quantity = this.dialogData.getQuantity(d);

                    const type = this.dialogData.getType(d);
                    if (!id) {
                        return { positionExisting: false, price: 0, sum: 0 };
                    }
                    const dataFromFile = fileDataMap.get(id);

                    let price = 0;
                    let sum = 0;
                    let poisitonExisting = true;
                    if (!dataFromFile && type !== AccountsReceivableLedgerTypeEnum.Group) {
                        if (type === AccountsReceivableLedgerTypeEnum.Text) {
                            return;
                        }
                        poisitonExisting = false;
                    } else if (type === AccountsReceivableLedgerTypeEnum.Group) {
                        isGroup = true;
                        const result = calculateGroupPrice(d);
                        sum = result.sum;
                        if (!result.positionExisting) {
                            poisitonExisting = false;
                        }


                    } else {
                        price = dataFromFile.price ?? null;
                        sum = quantity ? +quantity * price : price;

                        picePriceSum += price;
                        sumPriceSum += sum;
                    }
                    // Add position to FormRecord
                    if(!poisitonExisting && positionsExisting){
                        positionsExisting = false;
                    }
            const safePosSum = isNotNullOrUndefined(sum) && isFinite(sum) ? financialRound(sum) : 0;
            const safePrice = isNotNullOrUndefined(price) && isFinite(price) ? financialRound(price) : 0;
                    posValues[id.toString()] = {
                        changed: false,
                        isGroup: isGroup,
                        selectAble: poisitonExisting,
                        selected: false,
                        piecePrice: (type === AccountsReceivableLedgerTypeEnum.Group ? safePosSum : safePrice),
                        discountPrice: (type === AccountsReceivableLedgerTypeEnum.Group ? safePosSum : safePrice),
                        sumPrice: safePosSum,
                        loadingMaterialPrice: false,
                        materialId: this.dialogData.getMaterialId(d),
                        arlId: id,
                        quantity: quantity,
                        itemNumber: d.ItemNumber,
                    };


                })
                const bidderFormGroup: BidderFormGroup = new FormGroup({
                    customerId: new FormControl<number | null>(supplierId),
                    rabatt: new FormControl<number | null>(null),
                    skonto: new FormControl<number | null>(null),
                    sumPicePrice: new FormControl<number | null>(picePriceSum),
                    sumDiscountPrice: new FormControl<number | null>(picePriceSum),
                    sumSumPrice: new FormControl<number | null>(sumPriceSum),
                    selectAble: new FormControl<boolean>(positionsExisting),
                    priceComparisonId: new FormControl<string | null>(null),
                    positions: new FormRecord(
                        Object.fromEntries(
                            Object.entries(posValues).map(([key, value]) => [
                                key,
                                new FormGroup({
                                    isGroup: new FormControl(value.isGroup),
                                    selectAble: new FormControl(value.selectAble),
                                    selected: new FormControl({
                                        value: value.selected,
                                        disabled: !value.selectAble
                                    }),
                                    piecePrice: new FormControl(value.piecePrice),
                                    discountPrice: new FormControl(value.discountPrice),
                                    sumPrice: new FormControl(value.sumPrice),
                                    loadingMaterialPrice: new FormControl(value.loadingMaterialPrice),
                                    materialId: new FormControl(value.materialId),
                                    arlId: new FormControl(value.arlId),
                                    quantity: new FormControl(value.quantity),
                                    changed: new FormControl(value.changed),
                                    itemNumber: new FormControl(value.itemNumber),
                                })
                            ])
                        )
                    )
                });

                this.biddersFormArray.push(bidderFormGroup);

                this.bidderData.push({
                    bidderName: customer.DisplayName,
                    fileName: file.Name,
                    documentId: file.Id,
                    formGroup: bidderFormGroup,
                });
                this.recalculatePrices(bidderFormGroup)
                const rabattSub = bidderFormGroup.controls.rabatt.valueChanges.subscribe(() => {
                    this.recalculatePrices(bidderFormGroup);
                });
                const skontoSub = bidderFormGroup.controls.skonto.valueChanges.subscribe(() => {
                    this.recalculatePrices(bidderFormGroup);
                });
                this.formSubscriptions.push(rabattSub, skontoSub);
                this.updateArlFilter();
                this.cdr.markForCheck();
                this.ls.endLoading("addBidderFromFile")

    }



    protected updateArlFilter() {
        const arlIds = new Set<number>();
        this.bidderData.forEach(bidder => {
            Object.keys(bidder.formGroup.controls.positions.controls).forEach(key => {
                arlIds.add(+key);
            });
            console.log(bidder.formGroup.controls.positions.value)
        });
        const sortedArlIds = Array.from(arlIds).sort((a, b) => a - b);
        console.log('## update filter', sortedArlIds, )
        this.arlFilter$.next((a: InputFormValue) => sortedArlIds.includes(a.Id));
    }

    getPositionGroup(node: ArlNode<InputFormValue>, positions: BidderFormGroup['controls']['positions']) {
        return positions.controls[node.data.Id.toString()];
    }

    protected recalculatePrices(formGroup: BidderFormGroup) {
        let discountPriceSum = 0;
        let sumSumPrice = 0;


        const rabattPercent = formGroup.controls.rabatt?.value ?? 0;
        const skontoPercent = formGroup.controls.skonto?.value ?? 0;
        const totalDiscountPercent = rabattPercent + skontoPercent;

        const positoionFormValues = formGroup.controls.positions.value;

        const newValues: {[key: string]: {discountPrice: number, sumPrice: number}} = {};
        Object.values(positoionFormValues).forEach(position => {
            const discountPrice = financialRound(position.piecePrice * (1 - totalDiscountPercent / 100))
            const sumPrice = financialRound(discountPrice * (position.isGroup ? 1 :position.quantity ?? 1))
            if(!position.isGroup) {
                sumSumPrice += sumPrice;
                discountPriceSum += discountPrice;
            }
            newValues[position.arlId.toString()] = {discountPrice, sumPrice}
        });


        formGroup.patchValue({
            positions: newValues,
            sumDiscountPrice: discountPriceSum,
            sumSumPrice: sumSumPrice
            }
        )
         this.calculateHeaderMinMax();
    }



    public getQuantityTypeById$(id: number): Observable<string> {
        return getFetched$(this.store, getQuantityTypesFetched, getQuantityTypeById({ id })).pipe(map((entity) => entity.Name));
    }

    protected closeDialog(){
        if (this.dialogRef) {
            this.dialogRef.close();
        }
    }
    protected save(){
        let savePrices = false;
        let selectedPrice = false;
        const result: PriceComparisonComponentDialogReturnData['BidderData'] = this.bidderData.map(bidder => {
            const positions = bidder.formGroup.controls.positions.controls;

            const selectedPositions = Object.values(positions)
                .filter(pos => pos.value.selected)
                .map(pos => pos.value.arlId);

            if (selectedPositions.length > 0) {
                selectedPrice = true;
            }

            return {
                dirty: bidder.formGroup.dirty,
                priceComparisonId: bidder.formGroup.value.priceComparisonId,
                fileName: bidder.fileName,
                customerId: bidder.formGroup.value.customerId,
                rabatt: bidder.formGroup.value.rabatt,
                skonto: bidder.formGroup.value.skonto,
                selectedPositionsArlIds: selectedPositions,
                positions: Object.values(bidder.formGroup.controls.positions.getRawValue()),
                documentId: bidder.documentId,
            };
        });
        if(selectedPrice) {
           this.dialog.open<AppConfirmationDialogComponent, AppConfirmationDialogData, [boolean, string]>(AppConfirmationDialogComponent, {
                autoFocus: false,
                data: {
                    paragraph: `Sollen die ausgewählten Preise übernommen werden?`,
                    styleDelete: false,
                },
                maxWidth: '400px',
                width: '90%',
                // disableClose: true,
            }).afterClosed().subscribe((res) => {
                if (res && res[0]) {
                    savePrices = true;
                }else{
                    result.forEach(res => {
                        Object.values(res.positions).forEach(pos => {
                            pos.selected = false;
                        });
                    })
                }
               this.dialogRef.close({
                   SavePrices: savePrices,
                   BidderData: result
               });
            });
        }else{
            this.dialogRef.close({
                SavePrices: savePrices,
                BidderData: result
            });
        }


        console.log('Saving selected bidder data:', result);
    }

    maxSumSumPrice: number;
    minSumSumPrice: number;

    calculateHeaderMinMax() {
        const values = this.bidderData.map(b => b.formGroup.value.sumSumPrice);

        this.maxSumSumPrice = Math.max(...values);
        this.minSumSumPrice = Math.min(...values);
        this.calculatePositionMinMax();
    }
    maxSumPricePerNode: { [nodeId: string]: number } = {};
    minSumPricePerNode: { [nodeId: string]: number } = {};

    calculatePositionMinMax() {
        this.maxSumPricePerNode = {};
        this.minSumPricePerNode = {};

        const allNodeIds = new Set<string>();

        this.bidderData.forEach(bidder => {
            Object.keys(bidder.formGroup.controls.positions.controls)
                .forEach(id => allNodeIds.add(id));
        });
        allNodeIds.forEach(nodeId => {
            const values = this.bidderData.map(bidder => {
                const pos = bidder.formGroup.value.positions[nodeId];
                return pos?.selectAble ? pos?.sumPrice ?? 0 : 0;
            });
            const filteredValues = values.filter(v => v !== 0);

            this.maxSumPricePerNode[nodeId] =
                filteredValues.length ? Math.max(...filteredValues) : null;

            this.minSumPricePerNode[nodeId] =
                filteredValues.length ? Math.min(...filteredValues) : null;
        });
    }

    selectBidder(selectedIndex: number, checked: boolean) {
        this.bidderData.forEach((bidder, index) => {
            const selected = index === selectedIndex && checked;

            const positoionFormValues = bidder.formGroup.controls.positions.value;
            const newSelectValues: {[key: string]: {selected: boolean}} = {};
            if (Object.keys(bidder.formGroup.controls.positions.controls).length === 0) {
                return;
            }

            Object.values(positoionFormValues).forEach(position => {
                if(position?.selectAble) {

                    newSelectValues[position.arlId.toString()] = { selected }
                }
            });

            bidder.formGroup.controls.positions.markAsDirty();
            bidder.formGroup.controls.positions.patchValue(newSelectValues);

        this.cdr.markForCheck();
     });

    }

    selecetPosition(selectedIndex: number, selectedArlId: number, checked: boolean) {
        if (!checked) return;
        const key = selectedArlId.toString();

        const selectedPosition = this.bidderData[selectedIndex]?.formGroup.controls.positions.controls[key];
        const isGroup = selectedPosition?.controls.isGroup.value;
        const descendantIds = isGroup ? (this.findDescendantIds(selectedArlId) ?? []) : [];

        this.bidderData.forEach((bidder, index) => {
            if (index !== selectedIndex) {
                const position = bidder.formGroup.controls.positions.controls[key];
                if (position?.controls.selected.value) {
                    position.controls.selected.setValue(false);
                    position.markAsDirty();
                }
                descendantIds.forEach(descendantId => {
                    const descPos = bidder.formGroup.controls.positions.controls[descendantId.toString()];
                    if (descPos?.controls.selected.value) {
                        descPos.controls.selected.setValue(false);
                        descPos.markAsDirty();
                    }
                });
            } else if (isGroup) {
                descendantIds.forEach(descendantId => {
                    const descPos = bidder.formGroup.controls.positions.controls[descendantId.toString()];
                    if (descPos && !descPos.controls.selected.value) {
                        descPos.controls.selected.setValue(true);
                        descPos.markAsDirty();
                    }
                });
            }
        });

        this.cdr.markForCheck();
    }

    // private collectDescendantArlIds(items: arlTableDataArlForm['value'][]): number[] {
    //     return items.flatMap(item => [item.Id, ...this.collectDescendantIds(item.childArls ?? [])]);
    // }

    private collectDescendantIds(items: InputFormValue[]): number[] {
        return items.flatMap(item => [
            this.dialogData.getId(item),
            ...this.collectDescendantIds(
                this.dialogData.getChildren(item)
            )
        ]);
    }

    // private findDescendantArlIds(arlId: number, items = this.data): number[] | null {
    //     for (const item of items) {
    //         if (item.Id === arlId) {
    //             return this.collectDescendantIds(item.childArls ?? []);
    //         }
    //         if (item.childArls?.length) {
    //             const found = this.findDescendantArlIds(arlId, item.childArls);
    //             if (found !== null) return found;
    //         }
    //     }
    //     return null;
    // }
    private findDescendantIds(
        id: number,
        items: InputFormValue[] = this.data
    ): number[] | null {

        for (const item of items) {

            if (this.dialogData.getId(item) === id) {
                return this.collectDescendantIds(
                    this.dialogData.getChildren(item)
                );
            }

            const children =
                this.dialogData.getChildren(item);

            if (children.length) {
                const found =
                    this.findDescendantIds(id, children);

                if (found !== null) {
                    return found;
                }
            }
        }

        return null;
    }

    isBidderSelected(index: number): boolean {
        const bidder = this.bidderData[index];
        const positions = Object.values(bidder.formGroup.controls.positions.controls);

        return positions.length > 0 && positions.every(p => p.value.selected);
    }
    isBidderIndeterminate(index: number): boolean {
        const bidder = this.bidderData[index];
        const positions = Object.values(bidder.formGroup.controls.positions.controls);

        const selectedCount = positions.filter(p => p.value.selected).length;

        return selectedCount > 0 && selectedCount < positions.length;
    }

    deleteBidder(index: number){
        this.biddersFormArray.removeAt(index);
        this.bidderData.splice(index, 1);
        this.updateArlFilter();
        this.cdr.markForCheck();
    }


    protected longInformationClick(node: ArlNode<InputFormValue>) {
        this.dialog.open<PriceComparisonLongtextDialogComponent, PriceComparisonLongInformationDialogComponentDialogData, PriceComparisonLongInformationDialogComponentDialogReturnData>(PriceComparisonLongtextDialogComponent, {
            ...PriceComparisonLongtextDialogComponent.DefaultConfig,
            data: {
                arlInformation: node.data.Information,
                arlLongInformation: node.data.Longtext,
            },
        });
    }


    protected logChangedetection() {
        console.log('logChangedetection');
    }

    protected moveBidder(index: number, moveForward: boolean) {
        const newIndex = moveForward ? index + 1 : index - 1;
        if (newIndex >= 0 && newIndex < this.bidderData.length) {
            const temp = this.bidderData[index];
            this.bidderData[index] = this.bidderData[newIndex];
            this.bidderData[newIndex] = temp;
            this.biddersFormArray.removeAt(index);
            this.biddersFormArray.insert(newIndex, this.bidderData[index].formGroup);
            this.cdr.markForCheck();
        }
    }


}
